/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Experience_Findus_Proptech_PeriodInputs */

const en_experience_findus_proptech_period = /** @type {(inputs: Experience_Findus_Proptech_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FEB 2024 – OCT 2024`)
};

const ar_experience_findus_proptech_period = /** @type {(inputs: Experience_Findus_Proptech_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فبراير 2024 – أكتوبر 2024`)
};

const bn_experience_findus_proptech_period = /** @type {(inputs: Experience_Findus_Proptech_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ফেব্রু ২০২৪ – অক্টো ২০২৪`)
};

const de_experience_findus_proptech_period = /** @type {(inputs: Experience_Findus_Proptech_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FEB 2024 – OKT 2024`)
};

const es_experience_findus_proptech_period = /** @type {(inputs: Experience_Findus_Proptech_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FEBRERO 2024 – OCTUBRE 2024`)
};

const fr_experience_findus_proptech_period = /** @type {(inputs: Experience_Findus_Proptech_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FÉVRIER 2024 – OCT 2024`)
};

const pt_experience_findus_proptech_period = /** @type {(inputs: Experience_Findus_Proptech_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FEVEREIRO 2024 – OUT 2024`)
};

const zh_experience_findus_proptech_period = /** @type {(inputs: Experience_Findus_Proptech_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2024 年 2 月 – 2024 年 10 月`)
};

const tr_experience_findus_proptech_period = /** @type {(inputs: Experience_Findus_Proptech_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ŞUBAT 2024 – EKİM 2024`)
};

const ru_experience_findus_proptech_period = /** @type {(inputs: Experience_Findus_Proptech_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ФЕВ 2024 г. – ОКТЯБРЬ 2024 г.`)
};

const pl_experience_findus_proptech_period = /** @type {(inputs: Experience_Findus_Proptech_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LUTY 2024 – PAŹ 2024`)
};

/**
* | output |
* | --- |
* | "FEB 2024 – OCT 2024" |
*
* @param {Experience_Findus_Proptech_PeriodInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const experience_findus_proptech_period = /** @type {((inputs?: Experience_Findus_Proptech_PeriodInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Experience_Findus_Proptech_PeriodInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_experience_findus_proptech_period(inputs)
	if (locale === "bn") return bn_experience_findus_proptech_period(inputs)
	if (locale === "de") return de_experience_findus_proptech_period(inputs)
	if (locale === "es") return es_experience_findus_proptech_period(inputs)
	if (locale === "fr") return fr_experience_findus_proptech_period(inputs)
	if (locale === "pt") return pt_experience_findus_proptech_period(inputs)
	if (locale === "zh") return zh_experience_findus_proptech_period(inputs)
	if (locale === "tr") return tr_experience_findus_proptech_period(inputs)
	if (locale === "ru") return ru_experience_findus_proptech_period(inputs)
	if (locale === "pl") return pl_experience_findus_proptech_period(inputs)
	return en_experience_findus_proptech_period(inputs)
});